export default __webpack_public_path__ + "alberta-fab-next-visit-delete.8dbd76a49aa6653d7218.svg";